<template>
  <!-- Shared look of every confirmation popup (Figma "Sign Out-Option 3"): pattern band with a pink centred title and
       a red ✕, optional icon in a grey circle (only when the popup has one), the question, then the action button(s).
       Used by $confirmDialog, $dialog and the page-level "Are you sure …?" modals. -->
  <div class="font-roboto select-none">
    <div class="relative rounded-lg overflow-hidden h-[100px]">
      <img src="../../assets/images/profile-bg.png" alt="" class="w-full h-full object-cover">
      <h3 class="absolute inset-0 flex items-center justify-center m-0 px-12 text-center text-[20px] text-[#F67280]">
        {{ title }}
      </h3>
      <button v-if="closable" type="button" class="absolute top-[10px] right-[12px] w-[32px] h-[32px] z-10 flex items-center justify-center border-0 bg-transparent p-0 focus:!outline-none focus:!shadow-none"
        aria-label="Close" :data-bs-dismiss="bsDismiss ? 'modal' : null" @click="$emit('close')">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19" stroke="#EE5851" stroke-width="2.4" stroke-linecap="round" /></svg>
      </button>
    </div>
    <div v-if="imageSrc" class="mt-4 p-3 w-[80px] h-[80px] rounded-full mx-auto bg-[#F1F1F1]">
      <img :src="imageSrc" alt="" class="w-full h-full object-contain">
    </div>
    <div class="mt-4 mb-3 px-2 text-center text-[20px] leading-[28px] text-[#333333]">
      <slot />
    </div>
    <div v-if="!noActions" class="flex flex-wrap justify-center gap-[10px] pb-1">
      <slot name="actions">
        <button type="button" class="fxConfirmBtn" :disabled="disabled" @click="confirm">{{ buttonText }}</button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    // file name under assets/images (e.g. "logout-confirm-icon.svg") or an imported URL; none → no icon
    image: { type: String, default: null },
    buttonText: { type: String, default: 'Confirm' },
    closable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    // info popup closed only by the ✕ (an empty #actions slot would still render the default button)
    noActions: { type: Boolean, default: false },
    // inside a Bootstrap modal: the ✕ also closes it
    bsDismiss: { type: Boolean, default: false },
  },
  emits: ['close', 'confirm'],
  methods: {
    // a Bootstrap modal drops .show as soon as it starts closing, but its button stays clickable during the
    // fade: a second click there must not run the action again (QA D-44, D-32)
    confirm(e) {
      if (e.currentTarget.closest('.modal')?.classList.contains('show') === false) return;
      this.$emit('confirm');
    },
  },
  computed: {
    imageSrc() {
      if (!this.image) return null;
      if (/^(data:|https?:|\/|blob:)/.test(this.image)) return this.image;
      try {
        return require(`@/assets/images/${this.image}`);
      } catch (e) {
        return null;
      }
    },
  },
};
</script>
